import { ScissorOutlined } from "@ant-design/icons";
import MasterCrudScreen from "./Mastercrudscreen";
import { MASTERS } from "./Masterapi";
import { EMERALD, TEAL } from "./Mastertheme";

const config = {
    master: MASTERS.sleeves,
    title: "Offer Master",
    singular: "Offer",
    plural: "Offers",
    subtitle: "Manage offer types",
    icon: <ScissorOutlined />,
    from: EMERALD,
    to: TEAL,
    fields: [
        { name: "sleves", label: "Offers", placeholder: "e.g. 50%", required: true, icon: <ScissorOutlined /> },
    ],
};

export default function SleevesMaster() {
    return <MasterCrudScreen config={config} />;
}